import { Component, ChangeDetectionStrategy, input, output } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

interface Character {
  label: string;
  introImage: string;
}

@Component({
  selector: 'app-character-choice',
  standalone: true,
  imports: [NgOptimizedImage],
  templateUrl: './character-choice.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './character-choice.component.scss',
})
export class CharacterChoiceComponent {
  readonly characters = input<Character[]>([]);

  readonly fieldClicked = output<string>();

  onFieldClicked(field: string) {
    this.fieldClicked.emit(field);
  }
}
